$(document).ready(function () {
    $('[data-tag-filter]').on('click', function (e) {
        e.preventDefault();
        var $clickedFilter = $(this);

        $('[data-tag-filter]').removeClass('active');
        $clickedFilter.addClass('active');

        var tagFilter = $clickedFilter.data("tag-filter");
        console.log("Clicked tag: " + tagFilter);
        $('[data-tags]').each(function () { 
            var $taggedElement = $(this);
            // What tags do we have on this object
            // Split them at ';'
            var tags = $taggedElement.data("tags").split(";");

            // Hide per default
            $taggedElement.hide();
            $.each(tags, function (index, val) {
                console.log("Thingy has tag: " + val);
                // Does any of the tags match the clicked tagFilter?
                if (val === tagFilter) {
                    // Show if any tags matches the clicked one
                    $taggedElement.show();
                }
            });
        });
    });
});